/**
 * Botão de compartilhar o link, sempre à vista na barra (salas por link): copia o endereço e confirma
 * com um check por um instante (ou avisa que não conseguiu). É nele que o cartão do convite pousa
 * quando o primeiro convidado entra. Passa o documento do clique a `onClick`, para a cópia usar a
 * janela certa (a sala pode estar na janela flutuante).
 */
import { forwardRef } from 'react';
import { Check, Share2, TriangleAlert } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ROUND_BUTTON, SIZE } from './controlStyles';
import { useCopyFeedback } from './useCopyFeedback';

const ICON = Object.freeze({ idle: Share2, copied: Check, failed: TriangleAlert });
const TITLE = Object.freeze({
    idle: 'Copiar o link para compartilhar',
    copied: 'Link copiado',
    failed: 'Não foi possível copiar o link',
});

/** @param {{ variant: keyof typeof SIZE, onClick: (doc: Document) => unknown }} props */
export const ShareLinkButton = forwardRef(function ShareLinkButton({ variant, onClick }, ref) {
    const [status, copy] = useCopyFeedback(onClick);
    const Icon = ICON[status];
    return (
        <button
            ref={ref}
            type="button"
            aria-label="Compartilhar link"
            title={TITLE[status]}
            data-copy-state={status}
            onClick={(event) => copy(event.currentTarget.ownerDocument)}
            className={cn(ROUND_BUTTON, SIZE[variant].btn, status === 'copied' && 'text-cyan-300', status === 'failed' && 'text-amber-300')}
        >
            <Icon className={SIZE[variant].icon} aria-hidden="true" />
        </button>
    );
});
